
import { motion } from 'framer-motion';

export function ProjectOverview() {
  const projectInfo = [
    { label: '위치', value: '경기도 화성시 남양읍 남양리 2198번지 일원' },
    { label: '세대수', value: '지하2층~지상24층 556세대 (6개 단지)' },
    { label: '타입', value: '전용 84㎡(34평) 단일 타입' },
    { label: '구조', value: '4Bay 판상형, 전세대 남동 남서향' },
    { label: '주차', value: '지하1층~2층(지상 주차 없음)&lt;746대&gt;세대당 1.33대' },
    { label: '입주예정', value: '2028년 7월예정' }
  ];

  return (
    <section id="overview" className="py-12 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-12 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-2 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            단지 개요
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600">
            화성 남양뉴타운 우미린 에듀하이
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl order-2 lg:order-1"
          >
            <img
              src="https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/5b9c7fe7e701ecdcd44d9157958ba07e.png"
              alt="단지 전경"
              className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-full object-cover"
            />
          </motion.div>

          {/* Right - Info */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-1 lg:order-2"
          >
            <div className="space-y-3 sm:space-y-4 md:space-y-6">
              {projectInfo.map((info, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  className="bg-gray-50 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 hover:bg-amber-50 transition-colors"
                >
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-4">
                    <span className="text-xs sm:text-sm font-semibold text-gray-500 uppercase tracking-wide">
                      {info.label}
                    </span>
                    <span className="text-sm sm:text-base md:text-lg font-bold text-gray-900 sm:text-right">
                      {info.value}
                    </span>
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6, duration: 0.6 }}
              className="mt-6 sm:mt-8 md:mt-10 p-5 sm:p-6 md:p-8 bg-gradient-to-br from-amber-600 to-amber-500 rounded-xl sm:rounded-2xl shadow-xl"
            >
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">
                특별 분양 혜택
              </h3>
              <ul className="space-y-2 sm:space-y-3 text-white">
                <li className="flex items-start gap-2">
                  <i className="ri-check-double-line text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">분양가상한제 적용으로 합리적인 가격</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-double-line text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">선호도 높은 84㎡ 단일 타입</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-double-line text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base">우수한 교육환경 및 교통 인프라</span>
                </li>
              </ul>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
